import jwt_decode from 'jwt-decode';
import DataApi from '../api/DataApi';

/** Single-line label: Name | username | role */
export const formatRunAsLabel = (displayName, username, roleName, suffix = '') => {
  const n = (displayName || '').trim() || '—';
  const u = (username || '').trim() || '—';
  const r = (roleName || '').trim() || '—';
  const base = `${n} | ${u} | ${r}`;
  return suffix ? `${base} ${suffix}`.trim() : base;
};

export const getLoggedInUserId = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return '';
    const decoded = jwt_decode(token);
    return decoded?.id ? String(decoded.id) : '';
  } catch {
    return '';
  }
};

export const loggedInUserRunAsLabel = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return formatRunAsLabel('You', '—', '—', '(you)');
    const d = jwt_decode(token);
    const name =
      [d.firstname, d.lastname].filter(Boolean).join(' ').trim() ||
      (d.fullname && String(d.fullname).trim()) ||
      (d.email && String(d.email).trim()) ||
      'You';
    const un =
      (d.username && String(d.username).trim()) ||
      (d.email && String(d.email).trim()) ||
      '—';
    const role = (d.role_name && String(d.role_name).trim()) || '—';
    return formatRunAsLabel(name, un, role, '(you)');
  } catch {
    return formatRunAsLabel('You', '—', '—', '(you)');
  }
};

/** Normalize dashboard/user id from API (flat or { value }). */
export const pickRecordId = (row) => {
  if (!row || row.id == null) return '';
  const v = row.id;
  if (typeof v === 'object' && v !== null && 'value' in v && v.value != null) {
    return String(v.value).trim();
  }
  return String(v).trim();
};

export const runningUserApiRowToOption = (row) => {
  if (!row || row.id == null) return null;
  const id = pickRecordId(row);
  if (!id) return null;
  const name =
    (row.full_name && String(row.full_name).trim()) ||
    (row.email && String(row.email).trim()) ||
    'User';
  const label = formatRunAsLabel(name, row.username, row.role_name);
  return { id, label };
};

/**
 * Human-readable label for the effective dashboard run user (matches row-level security / report scope).
 */
export async function resolveDashboardRunUserDisplayLabel(runUserId) {
  if (runUserId == null || String(runUserId).trim() === '') {
    return '';
  }
  const id = String(runUserId).trim();
  const me = getLoggedInUserId();
  if (me && id === me) {
    return loggedInUserRunAsLabel();
  }
  try {
    const api = new DataApi('dashboard');
    const res = await api.get('/running-user-options?limit=500');
    const rows = res?.data?.success && Array.isArray(res.data.data) ? res.data.data : [];
    for (const row of rows) {
      const rid = pickRecordId(row);
      if (rid && rid === id) {
        const name =
          (row.full_name && String(row.full_name).trim()) ||
          (row.email && String(row.email).trim()) ||
          'User';
        return formatRunAsLabel(name, row.username, row.role_name);
      }
    }
  } catch (e) {
    console.warn('resolveDashboardRunUserDisplayLabel: could not load user list', e);
  }
  return formatRunAsLabel(`User ${id.slice(0, 8)}…`, '—', '—');
}
